module.exports = __webpack_public_path__ + "static/media/core.53c7d6ba.jpg";